module.exports = __webpack_public_path__ + "static/media/tick.1c46db22.svg";